import React, { useState, useEffect } from "react";
//Material ui core
import {
  Drawer,
  List,
  Typography,
  IconButton,
  ListItem,
  ListItemIcon,
  ListItemText,
  Tooltip,
} from "@material-ui/core";
//Material ui icons
import { MenuOpen } from "@material-ui/icons";
import { listItems } from "../../Util/DrawerUtils/index";
//React-router-dom
import { withRouter } from "react-router-dom";
import clsx from "clsx";
import { RouteContext } from "../../Context/RouteContext";
import { useContext } from "react";

const DrawerComp = (props) => {
  const { history, location, classes, open, handleDrawerClose, isMobile } =
    props;

  const { setRoute } = useContext(RouteContext);

  let activeLinkArray = [
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
  ];

  const [activeArray, setActiveArray] = useState(activeLinkArray);
  useEffect(() => {
    let activeLinkArrayClone = [
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
    ];
    let pageUrlArr = listItems.map((item) => item.pageURL);
    let activeIndex = pageUrlArr.findIndex(
      (item) => item === location.pathname
    );
    activeLinkArrayClone[activeIndex] = true;
    setActiveArray(activeLinkArrayClone);
  }, [location.pathname]);

  const handleClick = (pageURL, index) => {
    let activeItemArr = [
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
    ];
    setActiveArray(activeItemArr);
    activeItemArr[index] = true;
    setActiveArray(activeItemArr);
    setRoute(pageURL);
    history.push(pageURL);
    if (isMobile) {
      handleDrawerClose();
    } else {
      return;
    }
  };

  return (
    <div>
      <Drawer
        className={clsx(classes.drawer, {
          [classes.drawerOpen]: open,
          [classes.drawerClose]: !open,
        })}
        variant="permanent"
        classes={{
          paper: clsx({
            [classes.drawerOpen]: open,
            [classes.drawerClose]: !open,
          }),
        }}
        elevation={0}
      >
        <div className={classes.drawerHeader}>
          {open && (
            <Typography
              variant="h4"
              noWrap
              color="primary"
              className={classes.brandStylesII}
              align="left"
            >
              Insmeal
            </Typography>
          )}
          <IconButton onClick={handleDrawerClose}>
            <MenuOpen color="primary" />
          </IconButton>
        </div>
        <List>
          {listItems.map((item, index) =>
            open ? (
              <ListItem
                button
                onClick={() => handleClick(item.pageURL, index)}
                key={item.text}
                data-testid={`${item.text}-Link`}
              >
                <ListItemIcon
                  className={
                    activeArray[index] ? classes.active : classes.inactive
                  }
                >
                  <item.Icon />
                </ListItemIcon>
                <ListItemText
                  primary={item.text}
                  className={
                    activeArray[index] ? classes.active : classes.inactive
                  }
                />
              </ListItem>
            ) : (
              <Tooltip
                title={item.text}
                key={item.text}
                arrow
                placement="right"
              >
                <ListItem
                  button
                  onClick={() => handleClick(item.pageURL, index)}
                  key={item.text}
                >
                  <ListItemIcon
                    className={
                      activeArray[index] ? classes.active : classes.inactive
                    }
                  >
                    <item.Icon />
                  </ListItemIcon>
                </ListItem>
              </Tooltip>
            )
          )}
        </List>
      </Drawer>
    </div>
  );
};

export default withRouter(DrawerComp);
